<app-portal-modal-shell
  [title]="title"
  [subtitle]="message"
  [size]="size"
  [busy]="busy"
  [dismissible]="!busy"
  [showOverlay]="false"
  (dismiss)="dismiss()">
  <div class="portal-prompt-dialog__fields">
    <label class="form-label" *ngIf="inputLabel">{{ inputLabel }}</label>
    <input
      class="form-control"
      [type]="inputType"
      [placeholder]="placeholder"
      [ngModel]="value"
      (ngModelChange)="onValueChange($event)"
      [disabled]="busy"
      (keydown.enter)="$event.preventDefault(); submit()"
      autofocus />
    <div class="text-danger fs-8 mt-2" *ngIf="error">{{ error }}</div>
  </div>
  <div portalModalFooter class="d-flex justify-content-end flex-wrap gap-2 w-100">
    <app-portal-button
      layout="label"
      variant="light"
      [disabled]="busy"
      (pressed)="dismiss()">
      {{ cancelLabel || ('COMMON.CANCEL' | translate) }}
    </app-portal-button>
    <app-portal-button
      layout="label"
      [variant]="confirmVariant"
      [loading]="busy"
      [disabled]="busy"
      (pressed)="submit()">
      {{ confirmLabel || ('COMMON.CONFIRM' | translate) }}
    </app-portal-button>
  </div>
</app-portal-modal-shell>
